
<template>
  <div class="dashboard-container">
    <el-row :gutter="20">
      <el-col v-if="user?.role === 'ADMIN'" :span="4">
        <el-card>
            <div class="stat-card">
              <div class="stat-title">待审批的用户</div>
              <div class="stat-value">{{ applyingUserCount }}</div>
            </div>
        </el-card>
      </el-col>
      <el-col :span="user?.role === 'ADMIN' ? 4 : 5">
        <el-card>
          <div class="stat-card">
            <div class="stat-title">客户总数</div>
            <div class="stat-value">{{ customerCount }}</div>
          </div>
        </el-card> 
      </el-col>
      <el-col :span="user?.role === 'ADMIN' ? 4 : 5">
        <el-card>
          <div class="stat-card">
            <div class="stat-title">订单总数</div>
            <div class="stat-value">{{ projectCount }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="user?.role === 'ADMIN' ? 4 : 5">
        <el-card>
          <div class="stat-card">
            <div class="stat-title">未收款订单</div>
            <div class="stat-value stat-value-warning">{{ warningProjectCount }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="user?.role === 'ADMIN' ? 4 : 5">
        <el-card>
          <div class="stat-card">
            <div class="stat-title">已完成订单</div>
            <div class="stat-value stat-value-completed">{{ completedProjectCount }}</div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-card class="warning-projects">
      <template #header>
        <div class="header-container">
          <span>{{ isShowingWarning ? '未收款预警订单' : '已完成订单' }}</span>
          <el-button
            type="primary"
            size="small"
            @click="toggleTable"
            style="margin-left: 10px;"
          >
            {{ isShowingWarning ? '查看已完成订单' : '查看预警订单' }}
          </el-button>
        </div>
      </template>
      <div v-if="isShowingWarning">
        <el-table :data="warningProjects" style="width: 100%">
          <el-table-column prop="name" label="订单名称"></el-table-column>
          <el-table-column prop="customer.name" label="客户名称"></el-table-column>
          <el-table-column prop="balance" label="未收款金额"></el-table-column>
        </el-table>
      </div>
      <div v-else>
        <el-table :data="completedProjects" style="width: 100%">
          <el-table-column prop="name" label="订单名称"></el-table-column>
          <el-table-column prop="customer.name" label="客户名称"></el-table-column>
          <el-table-column prop="type" label="订单类型" :formatter="formatProjectType"></el-table-column>
          <el-table-column prop="estimatedAmount" label="预估贷款金额(万)"></el-table-column>
          <el-table-column prop="totalAmount" label="贷款金额(万)"></el-table-column>
          <el-table-column prop="salesRate" label="销售费率%" :formatter="formatRate"></el-table-column>
          <el-table-column prop="purchaseRate" label="采购费率%" :formatter="formatRate"></el-table-column>
          <el-table-column prop="taxRate" label="税率%" :formatter="formatRate"></el-table-column>
          <el-table-column min-width="98px;"  width="105px" prop="aplicationDate" label="申请时间" sortable :default-sort="{prop:'aplicationDate',order:'descending'}"></el-table-column>
          <el-table-column prop="status" label="状态" >
            <template #default="scope">
              <span :style="{ color: scope.row.status === ProjectStatus.Completed.value ?  '#7CCD7C':'#7D9EC0' }">
                {{ formatProjectStatus(scope.row) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="completedAmount" label="已完成金额(税前)"></el-table-column>
          <el-table-column prop="balance" label="服务费(税前)"></el-table-column>
          <el-table-column prop="user.username" label="负责人"></el-table-column>
          <el-table-column prop="completeTime" label="完成日期" :formatter="formatDate"></el-table-column>
        </el-table>
      </div>
      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :page-sizes="[5, 10, 20, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { UserStatus, ProjectStatus } from '@/store'

export default {
  setup() {
    const store = useStore()
    const user = computed(() => store.state.user)
    const isAdmin = computed(() => user.value?.role === 'ADMIN')

    // 分页相关状态
    const currentPage = ref(1)
    const pageSize = ref(10)
    const total = ref(0)
    const isShowingWarning = ref(true)
    const completedProjects = ref([])

    onMounted(() => {
      store.dispatch('fetchCustomers')
      store.dispatch('getAllProjects')
      fetchProjects(false, true)
      // fetchCompletedProjects()
  
      if (isAdmin.value) {
        store.dispatch('fetchUsers')
      }

    })

    // 分页变化处理
    const handleSizeChange = (size) => {
      pageSize.value = size
      if (!isShowingWarning.value) {
        fetchCompletedProjects()
      }else{
        fetchProjects(false, true)
      }
    }

    const handleCurrentChange = (current) => {
      currentPage.value = current
      if (!isShowingWarning.value) {
        fetchCompletedProjects()
      }else{
        fetchProjects(false, true)
      }
    }

    // 切换表格显示
    const toggleTable = () => {
      isShowingWarning.value = !isShowingWarning.value
      if (!isShowingWarning.value) {
        fetchCompletedProjects()
      }else{
        fetchProjects(false, true)
      }
    }

    // 获取已完成订单
    const fetchCompletedProjects = () => {
      // 这里假设store中有获取已完成订单的action，如果没有则需要实现
      // 或者过滤现有订单数据
      let includedComplete = true
      let isWarning = false
      fetchProjects(includedComplete, isWarning)
    }

    const fetchProjects = (includedComplete, isWarning) => {
      // 这里假设store中有获取已完成订单的action，如果没有则需要实现
      // 或者过滤现有订单数据
      // console.log("currentPage:",currentPage.value)
      // console.log("pageSize:",pageSize.value)
      store.dispatch('fetchProjects', {
        pagination: { currentPage: currentPage.value, pageSize: pageSize.value },
        includedComplete: includedComplete,
        isWarning: isWarning
      }).then(response => {
        // console.log("allProjects:",store.state.projects)
        currentPage.value = response.currentPage || 1
        total.value = response.total || 0
        const allProjects = response.data || []
        // console.log("allProjects:",allProjects)
        completedProjects.value = allProjects.filter(project =>
          project.status === ProjectStatus.Completed.value ||
          project.status === ProjectStatus.Closed.value
        )
        warningProjects.value = allProjects.filter(p =>
          p.status !== ProjectStatus.Completed.value && p.status !== ProjectStatus.Closed.value && p.paymentWarning
        )
        // console.log("warningProjects:",warningProjects.value) 
      })
    }

    const customerCount = computed(() => store.state.customers.length)
    const projectCount = computed(() => store.state.allProjects.length)
    const warningProjects = computed(() => store.getters.projectsWithWarnings)
    const warningProjectCount = computed(() => warningProjects.value.length)
    const completedProjectCount = computed(() => {
      return store.state.allProjects.filter(
        p => p.status === ProjectStatus.Completed.value || p.status ===ProjectStatus.Closed.value 
      ).length
    })
    const applyingUserCount = computed(() => {
      return store.state.users.filter(user => 
        user.status === UserStatus.APPLYING.value
      ).length
    })
    const formatProjectStatus = (row)=>{
      return Object.values(ProjectStatus).find(s => s.value === row.status)?.label || '未知状态'
    }
    const formatProjectType = (row) => {
      if (row.type === 'Purchase') return '采购订单'
      if (row.type === 'Sales') return '销售订单'
      return row.type || '未知类型'
    }

    return {
      customerCount,
      projectCount,
      warningProjects,
      warningProjectCount,
      completedProjectCount,
      applyingUserCount,
      isAdmin,
      user,
      formatProjectStatus,
      formatProjectType,
      // 分页相关
      currentPage,
      pageSize,
      total,
      handleSizeChange,
      handleCurrentChange,
      // 表格切换相关
      isShowingWarning,
      completedProjects,
      toggleTable,
      // 状态常量
      ProjectStatus
    }
  }
}
</script>

<style scoped>
.dashboard-container {
  padding: 20px;
}
.stat-card {
  text-align: center;
}
.stat-title {
  font-size: 14px;
  color: #909399;
}
.stat-value {
      font-size: 24px;
      font-weight: bold;
      margin-top: 10px;
    }
    .stat-value-warning {
      color: #982205;
    }
    .stat-value-completed {
      color: #7CCD7C;
    }
.warning-projects {
  margin-top: 20px;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pagination-container {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
}
</style>
